import { useEffect, useRef, useState } from "react";

interface ViewportResize {
  width: number;
  height: number;
  initialHeight: number;
  isKeyboardOpen: boolean;
}

export function useViewportResize(): ViewportResize {
  const initialHeightRef = useRef<number | null>(null);

  const [resize, setResize] = useState<ViewportResize>({
    width: window.innerWidth,
    height: window.visualViewport?.height ?? window.innerHeight,
    initialHeight: window.visualViewport?.height ?? window.innerHeight,
    isKeyboardOpen: false,
  });

  useEffect(() => {
    const handleResize = () => {
      const vh = window.visualViewport?.height ?? window.innerHeight;

      // zapisz initialHeight tylko raz
      if (initialHeightRef.current === null) {
        initialHeightRef.current = vh;
      }

      const initialHeight = initialHeightRef.current ?? vh;
      const isKeyboardOpen = vh < (initialHeight - 100);

      setResize({
        width: window.innerWidth,
        height: vh,
        initialHeight,
        isKeyboardOpen,
      });
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize);
      window.visualViewport.addEventListener("scroll", handleResize); // iOS czasem tylko "scroll" odpala
    }
    window.addEventListener("resize", handleResize);

    // pierwszy pomiar
    handleResize();

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize);
        window.visualViewport.removeEventListener("scroll", handleResize);
      }
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return resize;
}
